import { WeekNumbering } from '../api/types';

const MS_PER_DAY = 86400000;

/** Semaine ISO 8601 : les semaines commencent le lundi, la semaine 1 est celle qui contient le premier jeudi de l'année. */
function isoWeek(date: Date): number {
  const d = new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()));
  const dayNum = (d.getUTCDay() + 6) % 7; // lundi=0..dimanche=6
  d.setUTCDate(d.getUTCDate() - dayNum + 3); // jeudi de cette semaine
  const firstThursday = new Date(Date.UTC(d.getUTCFullYear(), 0, 4));
  const firstThursdayDayNum = (firstThursday.getUTCDay() + 6) % 7;
  firstThursday.setUTCDate(firstThursday.getUTCDate() - firstThursdayDayNum + 3);
  return 1 + Math.round((d.getTime() - firstThursday.getTime()) / (7 * MS_PER_DAY));
}

/** Semaine "américaine" courante (système Excel WEEKNUM 1) : la semaine 1 est celle qui contient le 1er janvier, les semaines commencent le dimanche. */
function usWeek(date: Date): number {
  const start = new Date(Date.UTC(date.getUTCFullYear(), 0, 1));
  const dayOfYear = Math.floor((date.getTime() - start.getTime()) / MS_PER_DAY);
  const jan1Weekday = start.getUTCDay(); // dimanche=0
  return Math.floor((dayOfYear + jan1Weekday) / 7) + 1;
}

export function weekNumber(date: Date, method: WeekNumbering): number {
  return method === 'US' ? usWeek(date) : isoWeek(date);
}
